<div class="container">
    <!-- front-end skills -->
    <div class="mt-4 mb-4">
        <!-- front-end skills  -->
        <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-header" style="background: #fff;">
                <h2 class="skill-role">Front-end</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-container *ngFor="let frntend of frontEndSkills">
                        <div class="col-md-2">
                            <div class="text-center">
                                <img src="{{frntend.image}}" alt="{{frntend.name}}">
                                <p>{{frntend.name}}</p>
                            </div>
                        </div>
                    </ng-container>
                    <div class="col-md-2">
                        <div class="text-center">
                            <img src="assets/images/skills/pwa.png" alt="PWA" style="width: 128px;">
                            <p>PWA</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- back-end skills -->
    <div class="mt-4 mb-4">
        <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-header" style="background: #fff;">
                <h2 class="skill-role">Back-end</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-container *ngFor="let bckend of backEndSkills">
                        <div class="col-md-2 col-sm-6">
                            <div class="text-center">
                                <img src="{{bckend.image}}" alt="{{bckend.name}}">
                                <p>{{bckend.name}}</p>
                            </div>
                        </div>
                    </ng-container>
                    <div class="col-md-2 col-sm-6">
                        <div class="text-center">
                            <h1 style="font-weight:200;margin-bottom: 0.7rem;">Express</h1>
                            <p>Expressjs</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- databases -->
    <div class="mt-4 mb-4">
        <!-- database skills  -->
        <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-header" style="background: #fff;">
                <h2 class="skill-role">Databases</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-container *ngFor="let dbskill of databaseSkills">
                        <div class="col-md-2">
                            <div class="text-center">
                                <img src="{{dbskill.image}}" alt="{{dbskill.name}}">
                                <p>{{dbskill.name}}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <!-- query -->
    <div class="mt-4 mb-4">
        <!-- query skills  -->
        <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-header" style="background: #fff;">
                <h2 class="skill-role">Query - Language, Interface, Modeling</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-container *ngFor="let qryInterface of queryInterfaces">
                        <div class="col-md-2">
                            <div class="text-center">
                                <img src="{{qryInterface.image}}" alt="{{qryInterface.name}}">
                                <p>{{qryInterface.name}}</p>
                            </div>
                        </div>
                    </ng-container>
                    <div class="col-md-2">
                        <div class="text-center">
                            <h3 style="font-weight:200;margin-bottom: 1.7rem;color: #8a1400;">Mongoose</h3>
                            <p>Mongoose</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- serverless -->
    <div class="mt-4 mb-4">
        <!-- serverless skills  -->
        <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-header" style="background: #fff;">
                <h2 class="skill-role">Serverless with CI/CD</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-container *ngFor="let srvrLess of serverLess">
                        <div class="col-md-2">
                            <div class="text-center">
                                <img src="{{srvrLess.image}}" alt="{{srvrLess.name}}">
                                <p>{{srvrLess.name}}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <!-- others -->
    <div class="mt-4 mb-4">
        <!-- other skills  -->
        <div class="card shadow p-3 mb-5 bg-white rounded">
            <div class="card-header" style="background: #fff;">
                <h2 class="skill-role">Others</h2>
            </div>
            <div class="card-body">
                <div class="row">
                    <ng-container *ngFor="let other of otherSkills">
                        <div class="col-md-2">
                            <div class="text-center">
                                <img src="{{other.image}}" alt="{{other.name}}">
                                <p>{{other.name}}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>